// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__FwWlr","left":"StickyBox_left__1RhQR","right":"StickyBox_right__18P2l"};